var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-article"},[_c('h2',{staticClass:"screen_out"},[_vm._v("카테고리")]),_c('div',{staticClass:"inner_main"},[_c('div',{staticClass:"area_category"},[_c('content-work'),_c('content-office'),_c('content-favorite')],1),_c('div',{staticClass:"area_category"},[_c('content-notice'),_c('content-approval'),_c('content-mail')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }